import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';

const Homepage = lazy(() => import('./Homepage'));

/**
 * The Example page route.
 */
const ExampleRoute: FuseRouteItemType = {
	path: 'home',
	element: <Homepage />,
	settings: {
		layout: {
			config: {
				toolbar: {
					showTitle: false,
					ignoreHome: true,
					showCrumbs: false,
				}
			}
		}
	}
};

export default ExampleRoute;
